var divider_viewer_rtlignore_default = {
  "divider-container": "f47r6",
  "divider-container--double": "XidZE",
  "divider": "fxyvq",
  "divider--single": "cSt-y",
  "divider--double": "Z4v1S",
  "divider--dashed": "_1pcFU",
  "divider--dotted": "cVqsP",
  "divider--small": "_0PBI2",
  "divider--medium": "prdCO",
  "divider--large": "czTi0",
  "divider--left": "QDrvI",
  "divider--center": "o9VWv",
  "divider--right": "nvWta",
  "svgFixerContainer": "nxzZa",
  "emptyChar": "_7r9Ck"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
